import FilesOption from './FilesOption'

export default FilesOption
